// extracted by mini-css-extract-plugin
module.exports = {"benefit":"benefit_style_benefit__34N3l","benefit-icon":"benefit_style_benefit-icon__1C5Kn","benefit-desc":"benefit_style_benefit-desc__nHSqT"};